import { HERO } from "@/constants/testIds";
import { useMousePosition } from "@/hooks/useMousePosition";
import { AuroraBackground } from "./AuroraBackground";
import { ParticleField } from "./ParticleField";
import { HeroContent } from "./HeroContent";
import { ScrollIndicator } from "./ScrollIndicator";

export const HeroCore = () => {
  const mouse = useMousePosition();

  return (
    <section
      id="home"
      data-testid={HERO.root}
      className="relative min-h-screen overflow-hidden bg-ink"
    >
      <AuroraBackground mouse={mouse} />
      <ParticleField />
      <HeroContent />
      <ScrollIndicator />
    </section>
  );
};
